import { render, staticRenderFns } from "./OrderActionsMenu.vue?vue&type=template&id=c5b80f92"
import script from "./OrderActionsMenu.vue?vue&type=script&lang=js"
export * from "./OrderActionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports